<template>
  <section class="c-poll-question">
    <header>
      <p class="u-hide-mobile">Poll</p>
      <p>Have your say! Please vote below</p>
    </header>
    <main
      v-if="
        currentPoll.private &&
          (currentPoll.created_user.id !== userId && !userInvited)
      "
    >
      <h1>Survey is private</h1>

      <p>You are not able to view this survey</p>
    </main>
    <main v-else-if="!currentPoll.multiple && entries.length > 0">
      <h1>Sorry</h1>

      <p>You can only submit one entry per survey</p>
    </main>
    <main v-else>
      <!-- private -->
      <div class="mask" v-if="isAdmin"></div>
      <h3>{{ currentPoll.title }}</h3>
      <p>{{ currentPoll.body }}</p>
      <div v-if="!isAnswered">
        <ol class="listless c-poll-question__list">
          <li v-for="choice in currentPoll.options" :key="choice.id">
            <input
              type="radio"
              :id="`choice_${choice.id}`"
              :value="choice"
              v-model="currentAnswer"
            />
            <label :for="`choice_${choice.id}`">{{ choice.name }}</label>
          </li>
        </ol>

        <p>
          <base-button
            type="button"
            :disabled="!currentAnswer"
            primary="true"
            @click="confirmAnswer"
            >Submit</base-button
          >
        </p>
      </div>

      <div v-else>
        <p>Thank you for submitting an answer.</p>
      </div>
    </main>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "form-poll",

  props: {
    poll: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      currentAnswer: null,
      isAnswered: false,
      currentPoll: null,
      entries: []
    };
  },

  computed: {
    isAdmin() {
      return this.$route.meta.isAdmin;
    },
    formattedOptions() {
      let returnStr = "";
      this.currentPoll.choices.forEach((choice) => {
        returnStr = `${returnStr}${choice.sortOrder}:${choice.label}\n`;
      });

      return returnStr.slice(0, -1);
    },
    userInvited() {
      if (!this.currentPoll.users) {
        return false;
      }
      const users = this.currentPoll.users.filter(
        (user) => user.id == this.$store.state.auth.currentUser.id
      );

      return users && users.length;
    },
    userId() {
      if (!this.$store.state.auth.currentUser.id) {
        this.$store.dispatch("auth/listCurrentUser").then((resp) => {
          return this.$store.state.auth.currentUser.id;
        });
      } else {
        return this.$store.state.auth.currentUser.id;
      }
    },
    userHasSubmitted() {
      // until we get a flag, see if we can hide from the user

      return true;
    },
  },
  methods: {
    confirmAnswer() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        confirm: async () => {
          try {
            await vm.$store.dispatch("Polls/setAnswer", {
              answer: this.currentAnswer,
              pollId: this.currentPoll.id,
            });
            this.setAnswered();
          } catch (err) {
            console.log(
              "TCL:  ~ file: FormPoll.vue ~ line 85 ~ confirm: ~ err",
              err
            );
          }
        },
      });
    },
    setAnswered() {
      this.isAnswered = true;
    },
  },
  async mounted() {
    // the current poll is overwritten in state if there are multiple polls on a page
    this.currentPoll = await this.$store.dispatch("Polls/load", this.poll);

    // get submissions so we can make sure user hasnt done it already
    this.entries = await this.$store.dispatch("Polls/getEntries", {
      formId: this.currentPoll.id,
      currentUser: true,
    });
  },
};
</script>

<style lang="scss" scoped>
.c-poll-question {
  background: $colour-polls-bg;
  position: relative;

  header {
    border-bottom: 1px solid
      rgba(
        red($colour-polls-darken),
        green($colour-polls-darken),
        blue($colour-polls-darken),
        0.1
      );
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    width: 100%;

    @media (min-width: 768px) {
      flex-direction: row;
      padding: 30px;
      > *:nth-last-child(1) {
        text-align: right;
      }
    }
  }

  main {
    padding: 20px;
    @media (min-width: 768px) {
      background-image: url("data:image/svg+xml,%3Csvg width='147' height='269' viewBox='0 0 147 269' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='147' height='269'%3E%3Crect width='147' height='269' fill='%23C4C4C4'/%3E%3C/mask%3E%3Cg mask='url(%23mask0)'%3E%3Cmask id='mask1' mask-type='alpha' maskUnits='userSpaceOnUse' x='-28' y='3' width='172' height='269'%3E%3Crect x='-28' y='3' width='172' height='269' fill='%23C4C4C4'/%3E%3C/mask%3E%3Cg mask='url(%23mask1)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M-69.2966 111.493L-56.1361 181.059C-79.4955 181.059 -87.4745 240.041 -56.1366 224.373L-69.2967 269L123 181.059L129.5 155.5L131 140.5L135 94.4999L121 71.4999L59.5005 111.493L49.5005 44.4999L-69.2966 111.493Z' fill='%23E5B3D0'/%3E%3C/g%3E%3C/g%3E%3Crect x='120' y='71' width='21' height='113' rx='2' fill='white'/%3E%3Crect x='84' y='101' width='21' height='83' rx='2' fill='white'/%3E%3Crect x='48' y='44' width='21' height='140' rx='2' fill='white'/%3E%3C/svg%3E%0A");
      min-height: 269px;
      padding-left: 167px;
    }

    ol {
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      li {
        box-sizing: border-box;
        // flex: 0 0 1;
        width: calc(100% - 20px);

        @media (min-width: 768px) {
          width: calc(50% - 20px);
        }

        input {
          position: absolute;
          left: -999rem;

          &:checked + label {
            background-image: url("data:image/svg+xml,%3Csvg width='13' height='10' viewBox='0 0 13 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.8096 0.199426C12.5558 -0.0664754 12.1443 -0.0664754 11.8904 0.199426L4.10298 8.35645L1.10963 5.22105C0.855803 4.95515 0.444272 4.95518 0.190391 5.22105C-0.0634638 5.48693 -0.0634638 5.91799 0.190391 6.18389L3.64336 9.80066C3.89711 10.0665 4.30895 10.0664 4.5626 9.80066L12.8096 1.16229C13.0635 0.896414 13.0634 0.465328 12.8096 0.199426Z' fill='%23B11F74'/%3E%3C/svg%3E%0A");
            background-position: 90% 50%;
            background-repeat: no-repeat;
          }
        }

        label {
          background: white;
          border: 1px solid white;
          border-radius: 72px;
          cursor: pointer;
          display: block;
          padding: 10px;

          &:hover {
            border-color: $colour-nhs-pink;
          }
        }
      }
    }
  }

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
